/**
 * Close footer mb
 */
const CloseFooter = ({ width = 16, height = 16, color = '#000000', rotate = 0, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate}deg)` }}
      {...props}>
      <path
        d="M2.23828 7.36062L2.23828 8.64062L6.71828 8.64062L7.35828 8.00062L6.71828 7.36062L2.23828 7.36062Z"
        fill={color}
      />
      <path
        d="M7.35672 13.7598L8.63672 13.7598L8.63672 9.27977L7.99672 8.63977L7.35672 9.27977L7.35672 13.7598Z"
        fill={color}
      />
      <path
        d="M13.7578 7.36062L13.7578 8.64062L9.27781 8.64062L8.63781 8.00062L9.27781 7.36062L13.7578 7.36062Z"
        fill={color}
      />
      <path
        d="M8.63938 2.24023L7.35938 2.24023L7.35937 6.72024L7.99937 7.36023L8.63937 6.72024L8.63938 2.24023Z"
        fill={color}
      />
    </svg>
  )
}

export default CloseFooter
